/* ============================================================
   JUSTIN B PERFUMES — "dynamic draft v3" interaction layer
   Unpublished duplicate theme only. Visual effects only:
   nothing here touches cart, checkout, prices, or inventory.
   All motion is skipped when prefers-reduced-motion is set.
   ============================================================ */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* ---------- 1. Scroll reveal ---------- */
  function initReveal() {
    var targets = document.querySelectorAll(
      '.product-card, [id*="marquee_dyn"], [id*="mood_picker_dyn"], [id*="hero_ywf8qi"]'
    );
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('dyn-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dyn-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el, i) {
      el.classList.add('dyn-reveal');
      if (el.classList.contains('product-card')) {
        el.style.transitionDelay = ((i % 4) * 100) + 'ms';
      }
      io.observe(el);
    });
  }

  /* ---------- 2. Hero parallax (desktop, subtle) ---------- */
  function initParallax() {
    if (reduceMotion || !finePointer) return;
    /* v3: follow the <picture> media box (same element the Ken Burns rule
       now animates); fall back to the img if no picture exists. */
    var heroMedia = document.querySelector('[id*="hero_iyt6zg"] picture.hero__media') ||
      document.querySelector('[id*="hero_iyt6zg"] img.hero__media');
    if (!heroMedia) return;
    var ticking = false;
    function update() {
      var rect = heroMedia.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) { ticking = false; return; }
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * 0.10;
      heroMedia.style.translate = '0 ' + offset.toFixed(1) + 'px';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- 3. Product-card tilt (desktop only, max 6deg) ---------- */
  function initTilt() {
    if (reduceMotion || !finePointer) return;
    document.querySelectorAll('.product-card').forEach(function (card) {
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          'translateY(-10px) perspective(700px) rotateX(' + (-py * 6).toFixed(2) +
          'deg) rotateY(' + (px * 6).toFixed(2) + 'deg)';
      });
      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ---------- 4. Add-to-cart micro-interaction (visual only) ---------- */
  function initCartPulse() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (!btn) return;
        btn.classList.add('dyn-adding');
        window.setTimeout(function () { btn.classList.remove('dyn-adding'); }, 800);
      });
    });
  }

  /* ---------- 5. Mood picker ---------- */
  function initMoodPicker() {
    var root = document.querySelector('[data-dyn-mood]');
    if (!root) return;
    var chips = root.querySelectorAll('[data-mood]');
    var panels = root.querySelectorAll('[data-mood-panel]');
    function select(mood) {
      chips.forEach(function (chip) {
        var active = chip.getAttribute('data-mood') === mood;
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) {
          root.style.setProperty('--mood-ring', chip.getAttribute('data-ring') || '#e8a33d');
        }
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-mood-panel') === mood);
      });
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        select(chip.getAttribute('data-mood'));
      });
    });
    var first = root.querySelector('[data-mood]');
    if (first) select(first.getAttribute('data-mood'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal(); initParallax(); initTilt(); initCartPulse(); initMoodPicker();
    });
  } else {
    initReveal(); initParallax(); initTilt(); initCartPulse(); initMoodPicker();
  }
})();
